const games = [
    {
        title: 'Shinkoto',
        image: 'shinkoto.png',
        description: `Shinkoto is a two-player abstract board game in which players first complete rounds of bidding on and placing pieces, then take turns moving their pieces to capture the core at the center of the board and bring it to their opponent's side.`,
        link: 'https://shinkoto.com/'
    },
    {
        title: 'Rune Shifter',
        image: 'runeshifter.png',
        description: `Rune Shifter is a puzzle game in which players slide runes across a grid in four directions, where runes block one another's paths. Matching runes merge when they collide, forming a single immovable rune that limits future movement. The goal is to merge all runes without trapping yourself along the way.`,
        link: 'https://runeshifter.com/'
    },
    {
        title: 'GRUFLE',
        image: 'grufle.png',
        description: `GRUFLE is a puzzle game where the goal is to slide pieces on to goal tiles. However, every piece slides one direction when clicked on, and a different direction when a different piece is clicked on. Players are scored based on how quickly they slide every piece onto a goal tile.`,
        link: 'https://grufle.com/'
    },
    {
        title: 'Life Dots',
        image: 'lifedots.png',
        description: `Life Dots is an evolution simulator in which independent agents perceive and interact with their environment. Dots can move, consume food and each other, grow, and reproduce. Each dot's behavior is determined by a neural network which evolves genetically with the rest of the dot's traits.`,
        link: 'https://www.lifedots.net'
    }
];

export default games;
